// assets
import { IconKey, IconDatabase, IconShoppingCart, IconBusinessplan } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconDatabase,
    IconShoppingCart,
    IconBusinessplan
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const admin = {
    id: 'admin',
    title: 'menu.admin.thisTitle',
    caption: 'menu.admin.thisSubtitle',
    type: 'group',
    roles: ['ADMIN', 'FINANCE', 'ACCOUNTING'],
    children: [
        {
            id: 'access',
            title: 'menu.admin.access.thisTitle',
            type: 'collapse',
            icon: icons.IconKey,
            roles: ['ADMIN'],
            children: [
                {
                    id: 'departemen',
                    title: 'menu.admin.access.departemen',
                    type: 'item',
                    url: '/master/departemen/list',
                    target: false
                },
                {
                    id: 'user',
                    title: 'menu.admin.access.user',
                    type: 'item',
                    url: '/access/backend-access/list',
                    target: false
                },
                {
                    id: 'cost-center',
                    title: 'menu.admin.access.costCenter',
                    type: 'item',
                    url: '/access/cost-center/tree',
                    target: false
                }
            ]
        },
        {
            id: 'master',
            title: 'menu.admin.masterData.thisTitle',
            type: 'collapse',
            icon: icons.IconDatabase,
            roles: ['ADMIN'],
            children: [
                {
                    id: 'produk',
                    title: 'menu.admin.masterData.produk',
                    type: 'item',
                    url: '/master/produk/list'
                },
                {
                    id: 'rasa',
                    title: 'menu.admin.masterData.rasa',
                    type: 'item',
                    url: '/master/rasa/list'
                },
                {
                    id: 'kategori-ukuran',
                    title: 'menu.admin.masterData.kategoriUkuran',
                    type: 'item',
                    url: '/master/kategori-ukuran/list'
                },
                {
                    id: 'ukuran',
                    title: 'menu.admin.masterData.ukuran',
                    type: 'item',
                    url: '/master/ukuran/list'
                },
                {
                    id: 'brand',
                    title: 'menu.admin.masterData.brand',
                    type: 'item',
                    url: '/master/brand/list'
                },
                {
                    id: 'sub-brand',
                    title: 'menu.admin.masterData.subBrand',
                    type: 'item',
                    url: '/master/sub-brand/list'
                },
                {
                    id: 'kategori-harga',
                    title: 'menu.admin.masterData.kategoriHarga',
                    type: 'item',
                    url: '/master/kategori-harga/list'
                }
            ]
        },
        {
            id: 'marketing',
            title: 'menu.admin.marketing.thisTitle',
            type: 'collapse',
            icon: icons.IconShoppingCart,
            roles: ['ADMIN', 'FINANCE', 'ACCOUNTING'],
            children: [
                {
                    id: 'customer',
                    title: 'menu.admin.marketing.account',
                    type: 'item',
                    url: '/master/account/list'
                },
                {
                    id: 'area',
                    title: 'menu.admin.marketing.area',
                    type: 'item',
                    url: '/master/area/list'
                }
            ]
        },
        {
            id: 'budgeting',
            title: 'menu.admin.budgeting.thisTitle',
            type: 'collapse',
            icon: icons.IconBusinessplan,
            roles: ['ADMIN', 'FINANCE', 'ACCOUNTING'],
            children: [
                {
                    id: 'periode-fiskal',
                    title: 'menu.admin.budgeting.periodeFiskal',
                    type: 'item',
                    url: '/budget/periode-fiskal/list'
                },
                {
                    id: 'promo-plan',
                    title: 'menu.admin.budgeting.promoPlan',
                    type: 'item',
                    url: '/budget/promo-plan/list'
                },
                {
                    id: 'kategori-promo',
                    title: 'menu.admin.budgeting.kategoriPromo',
                    type: 'item',
                    url: '/budget/kategori-promo/list'
                }
            ]
        }
    ]
};

export default admin;
